import { useSelector, type TypedUseSelectorHook } from 'react-redux'

import { type ReduxState } from './reducers'

export const useAppSelector: TypedUseSelectorHook<ReduxState> = useSelector
